import { render, staticRenderFns } from "./APi.vue?vue&type=template&id=05573a9c&scoped=true&"
import script from "./APi.vue?vue&type=script&lang=js&"
export * from "./APi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05573a9c",
  null
  
)

export default component.exports